import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";
import { UserSerializersUserByline } from "types/serializers";

type Props = {
  user: UserSerializersUserByline
  className?: string;
};

export default function GoalNav({ user, className }: Props) {
  return (
    <TabsNavContainer className={className}>
      <TabLink href={`/@${user.username}/goals`} size="md">
        <>Active</>
      </TabLink>
      <TabLink href={`/@${user.username}/goals/archived`} size="md">
        <>Archived</>
      </TabLink>
    </TabsNavContainer>
  );
}
